import { createUseStyles } from 'react-jss';
import spacing from '../../../utils/spacing.js';

const sizingMap = {
  padding: {
    xxs: ['xxs', 'xxs', 'xxs'],
    xs: ['xs', 'xs', 'xs'],
    sm: ['xs', 'sm', 'xs'],
    md: ['xs', 'md', 'xs'],
    lg: ['xs', 'md', 'md'],
    xl: ['0', 'md', 'sm'],
    xxl: ['0', 'lg', 'md']
  },
  height: {
    xxs: 'calc(1.25rem + 2px)',
    xs: 'calc(1.25rem + 2px)',
    sm: 'calc(2.5rem + 2px)',
    md: 'calc(3rem + 2px)',
    lg: 'calc(3.5rem + 2px)',
    xl: 'calc(4rem + 2px)',
    xxl: 'calc(5rem + 2px)'
  }
};
const buttonStyles = {
  position: 'relative',
  display: 'inline-flex',
  justifyContent: 'center',
  position: 'relative',
  alignItems: 'stretch',
  transition: 'background .3s ease, border .3s ease, padding .3s ease',
  cursor: ' pointer',
  overflow: 'hidden',
  textDecoration: 'none',
  border: 'none',
  cursor: 'pointer'
};
var styles = createUseStyles({
  '@keyframes Shake': {
    '10%, 90%': {
      transform: 'translate3d(-1px, 0, 0)'
    },
    '20%, 80%': {
      transform: 'translate3d(2px, 0, 0)'
    },
    '30%, 50%, 70%': {
      transform: 'translate3d(-4px, 0, 0)'
    },
    '40%, 60%': {
      transform: 'translate3d(4px, 0, 0)'
    }
  },
  '@keyframes Spin': {
    from: {
      transform: 'rotate(0deg)'
    },
    to: {
      transform: 'rotate(360deg)'
    }
  },
  Button: {
    ...buttonStyles,
    background: ({
      theme,
      color,
      gradient
    }) => gradient ? `linear-gradient(to bottom, ${theme.colors[gradient[0]]} 0%, ${theme.colors[gradient[1]]} 100%)` : theme.colors[color] || color,
    border: '2px solid rgba(0, 0, 0, 0)',
    borderColor: ({
      theme,
      color
    }) => theme.colors[color] || color,
    color: ({
      theme,
      txtColor
    }) => theme.colors[txtColor] || txtColor,
    minHeight: ({
      size,
      height
    }) => height ? null : sizingMap.height[size],
    transform: 'translate3d(0, 0, 0)',
    animation: ({
      shake
    }) => shake ? '$Shake 0.75s cubic-bezier(0.5, 0, 0.5, 1) both' : false,
    '&:hover': {
      background: ({
        theme,
        hoverColor
      }) => theme.colors[hoverColor] || hoverColor,
      color: ({
        theme,
        hoverTxtColor
      }) => theme.colors[hoverTxtColor] || hoverTxtColor
    },
    '&:focus': {
      boxShadow: ({
        theme
      }) => theme.depth.md,
      outline: 'none'
    }
  },
  ButtonOutline: {
    ...buttonStyles,
    border: '2px solid rgba(0, 0, 0, 0)',
    borderColor: ({
      theme,
      color
    }) => theme.colors[color] || color,
    color: ({
      theme,
      txtColor,
      color
    }) => theme.colors[txtColor] || theme.colors[color] || txtColor || color,
    minHeight: ({
      size,
      height
    }) => height ? null : sizingMap.height[size],
    '&:hover': {
      color: ({
        theme,
        hoverColor
      }) => theme.colors[hoverColor] || hoverColor,
      borderColor: ({
        theme,
        hoverColor
      }) => theme.colors[hoverColor] || hoverColor
    },
    '&:focus': {
      boxShadow: ({
        theme
      }) => theme.depth.md,
      outline: 'none'
    }
  },
  ButtonTitle: {
    display: 'inline-flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin: '0 auto',
    transform: 'translateY(0)',
    transition: 'transform .3s ease, padding .3s ease',
    zIndex: '5',
    pointerEvents: 'none',
    textDecoration: 'none',
    fontWeight: ({
      weight
    }) => weight,
    whiteSpace: ({
      whiteSpace
    }) => whiteSpace,
    padding: ({
      theme,
      hasLeftIcon,
      size,
      padding,
      pt,
      pe,
      pb,
      ps
    }) => spacing(theme, padding) || [[spacing(theme, pt) || theme.spacing[sizingMap.padding[size][0]] || '0', spacing(theme, pe) || theme.spacing[sizingMap.padding[size][1]] || '0', spacing(theme, pb) || theme.spacing[sizingMap.padding[size][0]] || '0', spacing(theme, ps) || (hasLeftIcon ? theme.spacing[sizingMap.padding[size][2]] : theme.spacing[sizingMap.padding[size][1]] || '0')]]
  },
  ButtonType: ({
    theme,
    font,
    nowrap
  }) => ({
    ...theme.typography[font],
    lineHeight: 1,
    whiteSpace: nowrap ? 'nowrap' : 'normal'
  }),
  ButtonIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:first-child': {
      paddingLeft: ({
        theme,
        size
      }) => theme.spacing[sizingMap.padding[size][2]]
    },
    '&:last-child': {
      paddingRight: ({
        theme,
        size
      }) => theme.spacing[sizingMap.padding[size][2]]
    }
  },
  ButtonIconCenter: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    paddingBottom: ({
      theme,
      size
    }) => theme.spacing.sm,
    '& img': {
      maxWidth: '120px',
      width: '100%'
    }
  },
  ButtonIconItem: {
    display: 'flex'
  },
  ButtonShake: {
    animation: '$Shake 0.5s cubic-bezier(0.5, 0, 0.5, 1) infinite'
  },
  ButtonIconLoading: {
    animation: '$Spin 2s linear infinite'
  },
  ButtonFailed: {
    background: ({
      theme
    }) => theme.danger,
    borderColor: ({
      theme
    }) => theme.danger,
    color: 'white'
  }
});

export { styles as default };
